import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import {
  DataBlocks,
  I18n,
  Link,
} from 'components';

import AccountPreview from '../AccountPreview';
import AccountGroupPreview from '../AccountGroupPreview';

import styles from './styles.pcss';

const cx = classNames.bind(styles);

class ContractPreview extends PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      hidden: true,
    };
  }

  render() {
    const {
      ban,
      login,
      nickName,
      bens,
      banInvoiceAddress,
      className,
      isPostpaid,
      subscribers,
      postpaidLimit,
      openAccountEditPopup,
      openContractEditPopup,
      unlinkAccount,
      openAccountGroupEditPopup,
    } = this.props;

    const { hidden } = this.state;

    return (
      <DataBlocks.TableRow
        className={cx(className)}
      >
        <DataBlocks.TableCell
          className={cx('accountCell')}
          colSpan="6"
        >
          <div className={cx('banHeader')}>
            <div
              role="presentation"
              className={cx('banTitleWrapper')}
            >
              <Link
                className={cx('banTitle')}
                onClick={() => this.setState({
                  hidden: !hidden,
                })}
              >
                <I18n
                  path="settings.numberManagement.associatedAccounts.contractTitle"
                  vars={{ ban }}
                />
              </Link>
              <i className={cx('arrow', {
                up: !hidden,
                down: hidden,
              })}
              />
            </div>
            <div className={cx('banDescription', { hidden })}>
              <span className={cx('banTypeLabel')}>
                {isPostpaid
                  ? <I18n path="settings.numberManagement.associatedAccounts.postpaid" />
                  : <I18n path="settings.numberManagement.associatedAccounts.prepaid" />}
              </span>
              <span className={cx('nickName')}>
                {nickName}
              </span>
            </div>
          </div>
          <div className={cx('linksWrapper')}>
            <Link
              className={cx('editLink')}
              onClick={() => openContractEditPopup({
                ban,
                login,
                nickName,
                isPostpaid,
                postpaidLimit,
                banInvoiceAddress,
              })}
            >
              <I18n path="common.edit" />
            </Link>
            <Link
              className={cx('unlink')}
              onClick={() => unlinkAccount({
                login,
                isMobile: true,
              })}
            >
              <I18n path="settings.numberManagement.associatedAccounts.unlink" />
            </Link>
          </div>
          <div className={cx({ hidden })}>
            {bens && [...bens]
              .sort((a, b) => a.ben - b.ben)
              .map((account) => (
                <AccountGroupPreview
                  key={`ben-${ban}-${account.ben}`}
                  isPostpaid={isPostpaid}
                  ban={ban}
                  login={login}
                  {...account}
                  openAccountEditPopup={openAccountEditPopup}
                  openAccountGroupEditPopup={openAccountGroupEditPopup}
                />
              ))}
            {subscribers
              && (
              <DataBlocks.Table className={cx('accountPreviewTable')}>
                {subscribers.map((account) => (
                  <AccountPreview
                    isMobile
                    key={`ctn-account-${account.login}`}
                    banLogin={login}
                    {...account}
                    openAccountEditPopup={openAccountEditPopup}
                  />
                ))}
              </DataBlocks.Table>
              )}
          </div>
        </DataBlocks.TableCell>
      </DataBlocks.TableRow>
    );
  }
}

ContractPreview.propTypes = {
  ban: PropTypes.number,
  login: PropTypes.string,
  nickName: PropTypes.string,
  isPostpaid: PropTypes.bool,
  bens: PropTypes.array,
  banInvoiceAddress: PropTypes.string,
  subscribers: PropTypes.array,
  postpaidLimit: PropTypes.object,
  openAccountEditPopup: PropTypes.func,
  openContractEditPopup: PropTypes.func,
  unlinkAccount: PropTypes.func,
  openAccountGroupEditPopup: PropTypes.func,
  className: PropTypes.any,
};

export default ContractPreview;
